export default function ChooseController(view) {
  return id => view.resolve(id);
}